import { ReactNode } from 'react';
import { TextVariant } from '../constants/types';

export const useTextVariant = <T extends Record<string, TextVariant>>(
  constants: T,
  isMobile: boolean,
) => {
  const getText = (key: keyof T): ReactNode => {
    const variant = constants[key];
    if (isMobile) return variant.mobile ?? variant.common;
    return variant.pc ?? variant.common;
  };

  return { getText };
};
